/*
 * Знаков после разделителя у валюты (ISO 4217 «minor unit») — ОДНА таблица для админки
 * (`@wit-support/ui-domain` реэкспортирует `currencyScale`) и MCP (`minorExponent` в ответах,
 * чтобы модель не делила на 100 там, где масштаб другой: JPY — 0, KWD — 3).
 */
/**
 * Число знаков после разделителя = степень десятки, на которую делится
 * минорная единица валюты (ISO 4217 «minor unit»).
 *
 * Зачем таблица. Деньги ходят по системе ЦЕЛЫМИ минорными единицами, и
 * восстановить мажорную сумму без масштаба нельзя: `1234` в JPY — это 1234
 * иены, а в USD — 12 долларов 34 цента. Функция раньше делила на 100 всегда,
 * из-за чего чарджбек на ¥1234 показывался оператору как «¥12.34» — в сто раз
 * меньше реального, ровно на том экране, где по сумме принимают решение.
 *
 * Отдельно и явно: НЕ полагаемся на то, что `Intl` знает число знаков валюты
 * сам. Знать-то он знает, но только для ФОРМАТИРОВАНИЯ, а поделить минорные
 * единицы на мажорные всё равно нам — и делить по одной таблице, а печатать по
 * другой значит однажды получить расхождение между ними. Поэтому и
 * `minimumFractionDigits`, и `maximumFractionDigits` берутся отсюда же.
 */
const CURRENCY_SCALE = {
    // Без дробной части.
    JPY: 0,
    KRW: 0,
    VND: 0,
    CLP: 0,
    ISK: 0,
    XOF: 0,
    XAF: 0,
    PYG: 0,
    RWF: 0,
    UGX: 0,
    VUV: 0,
    KMF: 0,
    DJF: 0,
    GNF: 0,
    // Три знака после разделителя.
    BHD: 3,
    KWD: 3,
    OMR: 3,
    TND: 3,
    JOD: 3,
    IQD: 3,
    LYD: 3,
};
/** Подавляющее большинство валют, включая все, которыми мы торгуем сегодня. */
const DEFAULT_CURRENCY_SCALE = 2;
/**
 * Знаков после разделителя у валюты (масштаб minor units) — по таблице выше;
 * регистр не важен; пусто или неизвестный код — 2. Единственная таблица
 * знаков валют в UI: и деление minor → major, и печать идут по ней.
 */
export function currencyScale(currency) {
    if (!currency)
        return DEFAULT_CURRENCY_SCALE;
    return CURRENCY_SCALE[currency.toUpperCase()] ?? DEFAULT_CURRENCY_SCALE;
}
//# sourceMappingURL=currency-scale.js.map